import { createContext } from "react";
import type { LanguageContextType } from "../types/LanguageType";

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);